// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentFilledSvg from "@ant-design/icons-svg/es/asn/EnvironmentFilled";
import AntdIcon from '../components/AntdIcon';

var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentFilledSvg
  }));
};

EnvironmentFilled.displayName = 'EnvironmentFilled';
export default React.forwardRef(EnvironmentFilled);